import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Icon, message } from 'antd';
import styled from 'styled-components';

import DefaulterNotices from '../DefaulterNotices';

var CardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
`;

var OptionCard = styled.div`
  background: ${function(p) { return p.active ? '#e6f7ff' : '#fff'; }};
  border: 2px solid ${function(p) { return p.active ? '#1890ff' : '#f0f0f0'; }};
  border-radius: 12px;
  padding: 24px 20px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
  position: relative;

  &:hover {
    border-color: ${function(p) { return p.active ? '#1890ff' : '#d9d9d9'; }};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }
`;

var CardIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: ${function(p) { return p.active ? '#1890ff' : '#f5f5f5'; }};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 14px;
  transition: all 0.2s;

  .anticon {
    font-size: 22px;
    color: ${function(p) { return p.active ? '#fff' : '#8c8c8c'; }};
  }
`;

var CardTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 6px;
`;

var CardDesc = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  line-height: 1.5;
`;

var CheckBadge = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #1890ff;
  display: flex;
  align-items: center;
  justify-content: center;

  .anticon {
    font-size: 12px;
    color: #fff;
  }
`;

var SectionLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #8c8c8c;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

var OPTIONS = [
  {
    value: 1,
    title: 'Cota única',
    desc: 'Pagamento integral em uma única parcela no mês de dezembro',
    icon: 'dollar',
  },
  {
    value: 2,
    title: 'Parcelado em 2x',
    desc: 'Primeira parcela em novembro e segunda em dezembro',
    icon: 'swap',
  },
  {
    value: 3,
    title: 'Parcelado em 3x',
    desc: 'Dividido em três parcelas de outubro a dezembro',
    icon: 'bars',
  },
];

var ModuleMonthlyForm = function(props) {
  var tenant = props.user.tenant;
  var currentValue = tenant.decimo_terceiro_split || 1;
  var savingState = useState(false);
  var isSaving = savingState[0];
  var setIsSaving = savingState[1];

  var handleSelect = function(value) {
    if (value === currentValue || isSaving) return;
    setIsSaving(true);
    props.saveConfig({ decimo_terceiro_split: value }).then(function() {
      message.success('Configuração salva com sucesso!');
      setIsSaving(false);
    }).catch(function() {
      setIsSaving(false);
    });
  };

  return React.createElement('div', null,
    React.createElement(SectionLabel, null,
      React.createElement(Icon, { type: 'gift', style: { fontSize: 14 } }),
      'Décimo Terceiro'
    ),
    React.createElement(CardsRow, null,
      OPTIONS.map(function(opt) {
        var isActive = currentValue === opt.value;
        return React.createElement(OptionCard, {
          key: opt.value,
          active: isActive,
          onClick: function() { handleSelect(opt.value); }
        },
          isActive && React.createElement(CheckBadge, null,
            React.createElement(Icon, { type: 'check' })
          ),
          React.createElement(CardIcon, { active: isActive },
            React.createElement(Icon, { type: opt.icon })
          ),
          React.createElement(CardTitle, null, opt.title),
          React.createElement(CardDesc, null, opt.desc)
        );
      })
    ),
    React.createElement(DefaulterNotices)
  );
};

var mapStateToProps = function(state) {
  return { user: state.user };
};

var mapDispatchToProps = function(dispatch) {
  return {
    saveConfig: function(data) {
      return dispatch({
        type: 'SAVE_CONFIG',
        payload: {
          request: {
            method: 'patch',
            url: '/tenant/config',
            data: data,
          },
        },
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModuleMonthlyForm);
